export class RecomendationData {
  private id: number
  private title: string
  private type: string

  constructor(id: number, title: string, type: string) {
    {
      this.id = id
      this.title = title
      this.type = type
    }
  }
}

export class Recomendation {
  public success: boolean
  public message: string
  public data?: RecomendationData[]

  constructor(success: boolean, message: string, data?: RecomendationData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}
